import { useEffect } from 'react';
import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider, theme } from 'antd';
import zhCN from 'antd/locale/zh_CN'

// import useLocale from '@/locales/useLocale';
import { useLayoutSettings } from '@/stores/layoutSettingStore';

import {
  customThemeTokenConfig,
  themeModeToken,
  colorPrimarys,
  customComponentConfig,
} from './theme';

import { ThemeMode } from '#/enum';
import StaticProvider from './staticProvider';
import { createStyles } from 'antd-style';

type Props = {
  children: React.ReactNode;
};
export default function AntdConfig({ children }: Props) {
  const { themeMode, themeColorPresets } = useLayoutSettings();
  const { styles } = useStyles();

  // const { language } = useLocale();

  const algorithm = themeMode === ThemeMode.Light ? theme.defaultAlgorithm : theme.darkAlgorithm;
  const colorPrimary =
    themeMode === ThemeMode.Dark ? '#8eb0d4' : colorPrimarys[themeColorPresets];

  useEffect(() => {
    const root = document.documentElement;
    const dark = themeMode === ThemeMode.Dark;
    root.classList.toggle('dark', dark);
    root.setAttribute('data-theme', themeMode);
    // 同步 body，避免 portal / 工作台露白底
    document.body.style.backgroundColor = dark ? '#121110' : '#f2f0eb';
    document.body.style.color = dark ? '#f0ebe4' : '#1a1816';
  }, [themeMode]);

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: { colorPrimary, ...customThemeTokenConfig, ...themeModeToken[themeMode].token },
        components: { ...customComponentConfig, ...themeModeToken[themeMode].components },
        algorithm,
      }}
      input={{ className: styles.input }}
      tabs={{ className: styles.tabs }}
    >
      {/* https://ant.design/docs/react/compatible-style-cn#styleprovider */}
      <StyleProvider hashPriority="high" layer>
        <StaticProvider>{children}</StaticProvider>
      </StyleProvider>
    </ConfigProvider>
  );
}



// Customize styles
const useStyles = createStyles(({ css, prefixCls, token }) => {
  const antCls = '.' + prefixCls
  return {
    tabs: css`
    &${antCls}-tabs-top>${antCls}-tabs-nav::before{
      border-color: ${token.colorBorder};
    }
    `,
    input: css`
      &${antCls}-input.no-border{
        border-color: transparent;
        &::placeholder{
          color: var(--ant-color-text);
        }
        &:hover {
          border-color: var(--ant-color-primary-border-hover);
        }
        &:focus {
          border-color: var(--ant-color-primary);
        }
        &:focus::placeholder{
          color: var(--ant-color-text-quaternary);
        }
      }
    `,
  }
});